import { Injectable } from '@angular/core';
import { ToastComponent } from '../../../core/components/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastComponent?: ToastComponent;

  constructor() { }

  setToastComponent(toastComponent: ToastComponent): void {
    this.toastComponent = toastComponent;
  }

  show(message: string, type: string = 'info', duration: number = 3000): void {
    // Se o componente de toast estiver configurado, usa ele
    if (this.toastComponent) {
      this.toastComponent.showToast(message, type, duration);
    } else {
      // Fallback: mostra no console quando o componente não está disponível
      const icon = type === 'success' ? '✅' : type === 'error' ? '❌' : 'ℹ️';
      console.log(`${icon} [${type.toUpperCase()}]: ${message}`);

      // Opcional: Mostrar alert apenas para erros críticos
      if (type === 'error') {
        // Comentado para não ser intrusivo, mas pode descomentar se necessário
        // alert(`${icon} ${message}`);
      }
    }
  }

}
